module.exports = __webpack_public_path__ + "img/strategies_talkAboutIt.85a6d799.png";